<div class="d_principalin" id="d_principalin">
    <div class="d_headernav d_navhome" id="d_navhome" style="display: flex;">
        <!--SEARCH BAR HOME-->
        <div class="d_headersearchgrl">
            <input class="d_headersearchinput" placeholder="Buscar actividades educativas" (input)="onSearch()"
                [(ngModel)]="searchTerm" [disabled]="!_conf.loggedIn">
            <div class="d_headersearchicon" [class.onHide]="searchTerm.length > 0" [innerHTML]="_icon.search"></div>

            <div class="d_headerclearicon" [class.onShow]="searchTerm.length > 0" [innerHTML]="_icon.filterclear"
                (click)="clearSearch()"></div>

            <div class="d_overlaycontegrl d_searchhome" id="d_overlaycontegrl_searchhome">
                <div class="d_overlaygrlsearch">
                    <div class="d_overlaygrlsearchclose" (click)="onToggleSearch();">
                        <div [innerHTML]="_icon.times"></div>
                    </div>

                    <div class="d_overlaygrlsearchinput">
                        <input class="d_overlaygrlsearchinputtext" [(ngModel)]="searchTerm" (input)="onSearch()">
                        <div class="d_headersearchicon" [class.onHide]="searchTerm.length > 0"
                            [innerHTML]="_icon.search"></div>

                        <div class="d_headerclearicon" [class.onShow]="searchTerm.length > 0" [innerHTML]="_icon.times"
                            (click)="clearSearch()"></div>
                    </div>

                    <p class="d_overlaygrlsearchtitle" *ngIf="searchTerm">
                        Resultados para: "{{ searchTerm }}"
                    </p>

                    <div *ngFor="let result of listCoincidencias" class="d_overlaygrlsearchoption"
                        (click)="result.action()">

                        <span class="d_overlaygrlsearchoptiondata">
                            <span class="d_galeria_numero d_num_search {{result.grado?.class}}">
                                {{result.grado?.n}}</span>
                            <p>|</p>

                            <span *ngIf="result.asignatura; else noAsignatura">
                                <div class="d_galeria_asignaturas" [class]="result.asignatura.class">
                                    <img [src]="_icon_asignatura.getIconByCssId(result.asignatura.class || 'd_asig_pri_def')"
                                        style="width: 2rem; height: 2rem;" />
                                </div>
                                <span>{{ result.asignatura.n }}</span>
                            </span>
                            <ng-template #noAsignatura>
                                <span>No se encontraron resultados para : {{ result.a }}</span>
                            </ng-template>


                            <p>|</p>
                            <span class="d_overlaygrlsearchoptiondata-text">{{result.listId.length}} Coincidencias
                                (actividades)</span>
                        </span>
                    </div>

                    <div *ngIf="searchTerm && searchResults.length === 0" class="d_no_results">
                        <p>No se encontraron resultados</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
